export const getModules = () =>
	Array.from(document.querySelectorAll("[data-js-module]")) as HTMLElement[]
export const getSpeedbumpLinks = () =>
	Array.from(document.querySelectorAll("a")) as HTMLAnchorElement[]
export const getChildren = (el, selector) =>
	Array.from(el.querySelectorAll(selector))
